// IFrame Player API の読み込みタグを挿入
const tag = document.createElement('script')
tag.src = "https://www.youtube.com/iframe_api"
const firstScriptTag = document.getElementsByTagName('script')[0]
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

// 関数onYouTubeIframeAPIReadyでiframeとYoutubeプレイヤーを作成
// let player
// window.onYouTubeIframeAPIReady = function () {
//   YT.ready(function () {
//     player = new YT.Player('ytplayer', {
//       videoId: 'IIUjG3nkdtg',
//       playerVars: {
//         'playsinline': 1
//       },
//       events: {
//         onReady: onPlayerReady,
//         onStateChange: onPlayerStateChange
//       }
//     })
//   })
// }

// function onPlayerReady(event) {
//   event.target.mute();
//   event.target.playVideo();
//   setTimeout(() => {
//     $('body').addClass('is--loaded');
//   }, 5000);
// }

// function onPlayerStateChange(event) {
//   if (event.data === YT.PlayerState.ENDED) {
//     event.target.playVideo()
//   }
// }

$(window).on('load', function() {
  $('body').addClass('is--loaded');
})

// smooth scroll
const scroll = new SmoothScroll('[data-scroll]', {
  speed: 1000,
  speedAsDuration: true
});

// mailto
function converter(M) {
  var str = "", str_as = "";
  for (var i = 0; i < M.length; i++) {
    str_as = M.charCodeAt(i);
    str += String.fromCharCode(str_as + 1);
  }
  return str;
}
function mail_to(k_1, k_2) {
  eval(String.fromCharCode(108, 111, 99, 97, 116, 105, 111, 110, 46, 104, 114, 101, 102, 32,
    61, 32, 39, 109, 97, 105, 108, 116, 111, 58)
    + escape(k_1) +
    converter(String.fromCharCode(98, 96, 109, 99, 120, 63, 111, 96, 111, 96, 97, 116, 97, 97, 107, 100, 45, 105, 111,
      62, 114, 116, 97, 105, 100, 98, 115, 60))
    + escape(k_2) + "'");
}

$('#mailto').on('click', function() {
  mail_to(mail_to("",""));
  return false;
});

// fade-in
$('.js--fade-up').on('inview', function() {
  $(this).addClass('is--inview');
})


// フォーム展開
function toggleOrderForm() {
  var formBuilder = document.querySelector('.globo-formbuilder');

  if (formBuilder.classList.contains('visible')) {
    formBuilder.classList.remove('visible');
  } else {
    formBuilder.classList.add('visible');
  }
}

function fixedCtaButton() {
  document.querySelector('.globo-formbuilder').classList.add('visible');
}
